import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import useSelector from 'hooks/use-selector'
import './index.css'
import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'
import isSampleVariantSelect from 'modules/product/redux/selectors/is-sample'
import getVariantIdFromUrlProductUtil from 'modules/product/utils/get-variant-id-from-url'
import isSampleStrVariantUtil from 'modules/variant/utils/is-sample-str'
import isDeluxeSampleVariantUtil from 'modules/variant/utils/is-deluxe-sample'
import getVariantUtil from 'modules/product/redux/selectors/get-variant-by-id/utils/get-variant'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import getSelectedColorOptionProductSelect from 'modules/variant/redux/selectors/get-selected-color-option'
import findVariantWithColorUtil from 'modules/product-variant/utils/find-variant-with-color'

import shouldHideVariantButtonsSelector from 'containers/QuickShopProductSidebar/components/VariantButtons/selectors/should-hide-variant-buttons'
import isSampleVariantUtil from 'modules/variant/utils/is-sample'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'
import FullSizeVariantButtons from 'containers/QuickShopProductSidebar/components/VariantButtons/components/FullSizeVariantButtons'

import getQuickShopHistoryProductsSelect from 'modules/product/redux/selectors/get-quick-shop-history'
import SampleVariantButtons from 'containers/QuickShopProductSidebar/components/VariantButtons/components/SampleVariantButtons'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariants
 * @return {JSX.Element}
 * @constructor
 */
const VariantButtons = ({
  productVariants
}) => {
  const dispatch = useDispatch()
  const variantIdFromUrl = getVariantIdFromUrlProductUtil()
  const quickShopHistory = useSelector(getQuickShopHistoryProductsSelect) || []

  // productVariants is the array which contains both full size and sample variants
  // for choosing full size variant iterate through the array and find the variant which is not sample and
  // its variant id === variantIdFromUrl if it is not found then choose the one which is not sample

  const fullSizeVariant = (
    productVariants?.find(
      variant => (
        variant.id === Number(variantIdFromUrl) &&
        !isSampleStrVariantUtil(variant.sku)
      )
    ) ||
    productVariants?.find(variant => !isSampleStrVariantUtil(variant.sku))
  )

  // for choosing sample variant iterate through the array and find the variant which is sample and
  // its variant id === variantIdFromUrl if it is not found then choose the one which is sample

  const sampleVariant = (
    productVariants?.find(
      variant => {
        return (
          variant.id === Number(variantIdFromUrl) &&
          isSampleVariantUtil(variant)
        )
      }
    ) ||
    productVariants?.find(variant => isSampleVariantUtil(variant))
  )

  const hideBothFullSizeAndSampleButtons = useSelector(shouldHideVariantButtonsSelector)
  const productVariant = useSelector(getCurrentVariantProductSelect)

  const selectedProductVariant = useSelector(getSelectedVariantSelect)
  const isSample = useSelector(isSampleVariantSelect)
  const shouldShowFullSizeVariant = !!fullSizeVariant && !hideBothFullSizeAndSampleButtons
  const shouldShowSampleVariant = !!sampleVariant && !hideBothFullSizeAndSampleButtons

  const fullSizeVariantRedux = useSelector(getByVariantIdDeepProductSelector(fullSizeVariant?.id))
  const sampleVariantRedux = useSelector(getByVariantIdDeepProductSelector(sampleVariant?.id))

  const isFullSizeActive = (
    fullSizeVariantRedux?.variant_id === productVariant?.variant_id ||
    isSample === false
  )

  const isADeluxeSample = isDeluxeSampleVariantUtil(sampleVariant)

  const [isSampleOutOfStock, setIsSampleOutOfStock] = React.useState(false)
  const [isFullSizeOutOfStock, setIsFullSizeOutOfStock] = React.useState(false)

  const selectedColorOption = useSelector(getSelectedColorOptionProductSelect)

  const sampleVariants = productVariants?.filter(variant => isSampleVariantUtil(variant))
  const fullSizeVariants = productVariants?.filter(variant => !isSampleVariantUtil(variant))

  const otherFullSizeVariants = fullSizeVariants?.filter(variant => parseFloat(variant?.price) !== parseFloat(fullSizeVariantRedux?.price) && !isSampleVariantUtil(variant))

  const otherSampleVariants = (
    sampleVariantRedux?.variants?.filter(variant => parseFloat(variant?.price) !== parseFloat(sampleVariantRedux?.price) && isSampleVariantUtil(variant))
  )

  const debugProps = {
    productVariants,
    fullSizeVariant,
    sampleVariant,
    isSample,
    isADeluxeSample,
    isSampleOutOfStock,
    isFullSizeOutOfStock,
    isFullSizeActive,
    productVariant,
    selectedProductVariant,
    fullSizeVariantRedux,
    otherFullSizeVariants,
    sampleVariantRedux,
    shouldShowFullSizeVariant,
    shouldShowSampleVariant,
    otherSampleVariants,
    sampleVariants,
    fullSizeVariants
  }

  logUtil('VariantButtons').debug('debugProps=life', debugProps)

  React.useEffect(() => {
    if (sampleVariant) {
      dispatch(
        loadByIdDeepProductVariantAction(sampleVariant?.id)
      )
    }
  }, [sampleVariant])

  React.useEffect(() => {
    if (fullSizeVariant) {
      dispatch(
        loadByIdDeepProductVariantAction(fullSizeVariant?.id)
      )
    }
  }, [fullSizeVariant])

  React.useEffect(() => {
    if (otherSampleVariants?.length) {
      dispatch(loadByIdDeepProductVariantAction(otherSampleVariants[0]?.variant_id))
    }
  }, [otherSampleVariants])

  React.useEffect(() => {
    if (otherFullSizeVariants?.length) {
      dispatch(loadByIdDeepProductVariantAction(otherFullSizeVariants[0]?.id))
    }
  }, [otherFullSizeVariants])

  const loadVariants = async () => {
    if (sampleVariant) {
      const sampleProductVariant = getVariantUtil(sampleVariantRedux, sampleVariant?.id)
      setIsSampleOutOfStock(!sampleProductVariant?.available)
    }

    if (fullSizeVariant) {
      const fullSizeProductVariant = getVariantUtil(fullSizeVariantRedux, fullSizeVariant?.id)
      setIsFullSizeOutOfStock(!fullSizeProductVariant?.available)
    }
  }

  React.useEffect(() => {
    loadVariants()
  }, [quickShopHistory])

  React.useEffect(() => {
    findVariantWithColorUtil(
      fullSizeVariantRedux?.fullsize_variants,
      selectedColorOption
    )

    let selectedVariant
    if (isFullSizeActive) {
      selectedVariant = findVariantWithColorUtil(
        fullSizeVariantRedux?.fullsize_variants,
        selectedColorOption
      )
    } else {
      selectedVariant = findVariantWithColorUtil(
        sampleVariantRedux?.sample_variants,
        selectedColorOption
      )
    }

    if (
      isFullSizeActive &&
      !selectedVariant
    ) {
      selectedVariant = findVariantWithColorUtil(
        sampleVariantRedux?.deluxe_sample_variants,
        selectedColorOption
      )
    }

    if (!selectedVariant) {
      return
    }

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: selectedVariant?.variant_id,
        shouldAddToUrl: false
      })
    )
  }, [
    isFullSizeActive,
    productVariant,
    selectedColorOption
  ])

  if (
    !fullSizeVariantRedux ||
    !sampleVariantRedux
  ) {
    return
  }

  return (
    <div className='variant-buttons-wrapper'>
      {shouldShowSampleVariant && (
        <SampleVariantButtons
          sampleVariants={sampleVariants}
          isSampleOutOfStock={isSampleOutOfStock}
        />
      )}

      {shouldShowFullSizeVariant && (
        <FullSizeVariantButtons
          fullSizeVariants={fullSizeVariants}
          isFullSizeOutOfStock={isFullSizeOutOfStock}
        />
      )}

    </div>
  )
}

export default VariantButtons
